module.exports = __webpack_public_path__ + "images/45b39de682096ce457495db2a28a2652.png";